import { render, staticRenderFns } from "./OneMonthAdd.vue?vue&type=template&id=60f8cc32&"
import script from "./OneMonthAdd.vue?vue&type=script&lang=ts&"
export * from "./OneMonthAdd.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports